import { FilledTextFieldProps, OutlinedTextFieldProps, StandardTextFieldProps, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { format } from 'fecha';
import React, { useEffect, useState } from 'react'
import toUpperCamelCase from '../../../view-model/Funciones/toUpperCamelCase'

//Iconos
import IViewDatosPersonales from '../../../view-interfaces/IViewDatosPersonales';
import IViewComunasAuto from '../../../view-interfaces/IViewComunasAuto';
import IViewPaisNacionalidadCmb from '../../../view-interfaces/IViewPaisNacionalidadCmb';

import IViewResultado from "../../../view-interfaces/IViewResultado";
import { GrabarDatosPersonalesLogic } from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import { useHistory, useLocation } from 'react-router-dom';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';

type Props = {
    codigoNegocio: number;
    carrera: string;
    anioPromocion: number,
    periodoPromocion: number,
    alumno: IViewDatosPersonales[];
    listaComunas: IViewComunasAuto[];
    listaPaisNacionalidad: IViewPaisNacionalidadCmb[];
    callback: any;
    validar: boolean;
    guardar: boolean;
}

export const Alumno: React.FC<Props> = ({ codigoNegocio, carrera, anioPromocion, periodoPromocion, alumno, listaComunas, listaPaisNacionalidad, callback, validar, guardar }) => {
    const history = useHistory();
    const location = useLocation();

    const [rutCompleto, setRutCompleto] = useState('');
    const [rut, setRut] = useState(0);
    const [dv, setDV] = useState('');
    const [nombres, setNombres] = useState('');
    const [apPaterno, setApPaterno] = useState('');
    const [apMaterno, setApMaterno] = useState('');
    const [fechaNacimiento, setFechaNacimiento] = useState('');
    const [direccion, setDireccion] = useState('');
    const [telefono, setTelefono] = useState(0);
    const [mail, setMail] = useState('');
    const [mailUdd, setMailUdd] = useState('');
    const [codSexo, setCodSexo] = useState(0);
    const [sexo, setSexo] = useState('');

    const _listComuna: IViewComunasAuto = { ID: 0, descripcion: '' };
    const [valComuna, setValComuna] = useState(_listComuna);
    const [codComuna, setCodComuna] = useState(0);
    const [comuna, setComuna] = useState('');

    const _listPaisNacionalidad: IViewPaisNacionalidadCmb = { ID: 0, descripcion: '' };
    const [valPaisNacionalidad, setValPaisNacionalidad] = useState(_listPaisNacionalidad);
    const [codPais, setCodPais] = useState(0);
    const [nacionalidad, setNacionalidad] = useState('');

    const [error, setError] = useState(true);
    const listaResultado: Array<IViewResultado> = [];
    const [listParams, setlistParams] = useState(listaResultado);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
  const [codNegocio, setCodNegocio] = useState(0)

    const defaultProps = {
        options: listaComunas,
        getOptionLabel: (option: IViewComunasAuto) => option.descripcion
    };

    const handleSelectComuna = (event: any, newValue: any) => {
        if (newValue !== null) {
            setCodComuna(newValue.ID);
            setComuna(newValue.descripcion);
            setValComuna(newValue);
        }
    }

    const handleSelectPaisNacionalidad = (event: any, newValue: any) => {
        if (newValue !== null) {
            setCodPais(newValue.ID);
            setNacionalidad(newValue.descripcion);
            setValPaisNacionalidad(newValue);
        }
    }

    useEffect(() => {
        if (guardar) {
            handleValidarDatos();
        }
    }, [guardar])

    useEffect(() => {
        if (error === false) {
            handleGrabarDatos()
            setError(true)
        }
    }, [error])

    const handleCargaDatos = () => {
        if (alumno.length > 0 && alumno[0].run > 0) {
            setRut(alumno[0].run);
            setRutCompleto(alumno[0].runFormato);
            setDV(alumno[0].dv);
            setNombres(alumno[0].nombres);
            setApPaterno(alumno[0].primerApellido);
            setApMaterno(alumno[0].segundoApellido);

            //var _fecha = '';
            let _fecha = (alumno[0].fechaNacimiento === '1900-01-01') ? '' : format(new Date(alumno[0].fechaNacimiento), 'YYYY-MM-DD');
            //var _fecha = (format(new Date(alumno[0].fechaNacimiento), 'YYYY-MM-DD') === "1900-01-01") ? '' : format(new Date(alumno[0].fechaNacimiento), 'YYYY-MM-DD');
            //var _fecha = (format(new Date(alumno[0].fechaNacimiento), 'YYYY-MM-DD') === "1900-01-01") ? '' : new Date(alumno[0].fechaNacimiento);
            //if (format(new Date(alumno[0].fechaNacimiento), 'YYYY-MM-DD') !== "1899-12-31") {
            // if (format(new Date(alumno[0].fechaNacimiento), 'YYYY-MM-DD') !== "1900-01-01") {
            //     let dateFN = new Date(alumno[0].fechaNacimiento);
            //     dateFN.setDate(dateFN.getDate() + 1);
            //     _fecha = format(dateFN, 'YYYY-MM-DD');
            // }

            setFechaNacimiento(_fecha);
            setCodSexo(alumno[0].codSexo);
            setSexo(alumno[0].sexo);
            setDireccion(alumno[0].direccion);
            setCodComuna(alumno[0].codigoComuna);
            setComuna(alumno[0].nombreComuna);

            setTelefono(alumno[0].telefono);
            setMail(alumno[0].email);
            setMailUdd(alumno[0].emailUDD);
            setCodPais(alumno[0].idPais);
            setNacionalidad(alumno[0].nacionalidad);

            console.log("PARAMETRO ALUMNO")
            console.log(alumno[0]);

            if (listaComunas.length > 0) {
                let _comuna = listaComunas.find(com => com.ID === alumno[0].codigoComuna);
                setValComuna({
                    ID: (_comuna?.ID !== undefined ? _comuna.ID : 0),
                    descripcion: (_comuna?.descripcion !== undefined ? _comuna.descripcion : '')
                });
            }

            if (listaPaisNacionalidad.length > 0) {
                let _paisNacionalidad = listaPaisNacionalidad.find(com => com.ID === alumno[0].idPais);
                setValPaisNacionalidad({
                    ID: (_paisNacionalidad?.ID !== undefined ? _paisNacionalidad.ID : 0),
                    descripcion: (_paisNacionalidad?.descripcion !== undefined ? _paisNacionalidad.descripcion : '')
                });
            }
        }
    }

    const handleValidarDatos = () => {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        try {
            if (direccion === "" || direccion === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar la dirección del postulante.");
                callback(false, "Debe ingresar la dirección del postulante.");
            }
            else if (direccion.length < 3) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar la dirección correctamente.");
                callback(false, "Debe ingresar la dirección correctamente.");
            }
            else if (codComuna === 0) {
                setError(true);
                //setMjeErrorAlerta("Debe seleccionar una comuna.");
                callback(false, "Debe seleccionar una comuna.");
            }
            else if (telefono === 0 || telefono === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el teléfono del postulante.");
                callback(false, "Debe ingresar el teléfono del postulante.");
            }
            else if (telefono.toString().length !== 9) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar teléfono correctamente del postulante.");
                callback(false, "Debe ingresar teléfono correctamente del postulante.");
            }
            else if (mail === "" || mail === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar el Email del postulante.");
                callback(false, "Debe ingresar el Email del postulante.");
            }
            else if (!regEmail.test(mail)) {
                setError(true);
                //setMjeErrorAlerta("Debe ingresar un Email válido.");
                callback(false, "Debe ingresar un Email válido.");
            }
            else if (codPais === 0 || nacionalidad === "" || nacionalidad === undefined) {
                setError(true);
                //setMjeErrorAlerta("Debe seleccionar la nacionalidad.");
                callback(false, "Debe seleccionar la nacionalidad.");
            }
            else {
                setError(false);
                //setValidado(true);
                callback(true);
            }
        } catch (e: any) {
            setError(true);
            callback(false, "Ocurrio un error al validar sus datos.");
        }
    }

    const handleGrabarDatos = () => {
        if (error === false) {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            console.log(_params)
            callback(false, "Guardando...", false)
            GrabarDatosPersonalesLogic(selResultadoParametros, _params.headers, 0, rutCompleto, "", nombres, apPaterno, apMaterno, new Date(fechaNacimiento),
                codComuna, comuna, direccion, telefono, mail, codSexo, sexo, codPais, nacionalidad, codPais, nacionalidad,
                rut, codigoNegocio, carrera, anioPromocion, periodoPromocion, 0, 1);
        }
    }

    const selResultadoParametros = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setlistParams(Resultado);
                callback(false, "Se ha guardado correctamente la información.", true);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    }

    useEffect(() => {
        handleCargaDatos();
    }, []);

    useEffect(() => {
        callback(false, '', false);
    }, [rut, nombres, apMaterno, apPaterno, fechaNacimiento, direccion, codComuna, telefono, mail, nacionalidad]);

    return (
        <>
            <div className="personal-information__content tab-content" id="nav-tabContent">
                {/* <button className="btn btn-link personal-information__toggle js-toggle-data-nav d-lg-none" type="button">
                <svg className="svg-chevron-left-dims"><use xlinkHref={B1+"#chevron-left"}></use></svg>
                Volver a datos personales
            </button> */}
                <div className="tab-pane fade show active" id="student-data" role="tabpanel" aria-labelledby="student-tab">
                    <h3 className="personal-information__content-title">Datos del alumno</h3>
                    <form id="form-datos-personales" className="personal-information__form">
                        <div className="form-content">
                            <div className="form-group">
                                <label htmlFor="rut">RUT</label>
                                <input id="rut"
                                    name="rut"
                                    className="form-control js-rut js-will-validate"
                                    type="text"
                                    value={rutCompleto}
                                    disabled={true} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="firstname">Nombres</label>
                                <input id="firstname"
                                    name="firstname"
                                    className="form-control js-will-validate"
                                    type="text"
                                    value={nombres}
                                    disabled={true} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="firstlastname">Primer Apellido</label>
                                <input id="firstlastname"
                                    name="firstlastname"
                                    className="form-control js-will-validate"
                                    type="text"
                                    value={apPaterno}
                                    disabled={true} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="secondlastname">Segundo Apellido</label>
                                {/* <label htmlFor="secondlastname">Apellido materno <span className="required">*</span></label> */}
                                <input id="secondlastname"
                                    name="secondlastname"
                                    className="form-control js-will-validate"
                                    type="text"
                                    value={apMaterno}
                                    disabled={true} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="birthdate">Fecha de Nacimiento</label>
                                <input id="birthdate"
                                    name="birthdate"
                                    className="form-control js-will-validate"
                                    type="date"
                                    value={fechaNacimiento}
                                    disabled={true} />
                            </div>
                            {/* <div className="form-group form-group--genero">
                                <Autocomplete
                                    {...generoProps}
                                    id="auto-complete"
                                    autoComplete
                                    includeInputInList
                                    renderInput={(params) => <TextField {...params} label="Genero" margin="normal" />} />
                            </div> */}
                            <div className="form-group form-group--genero">
                                <label htmlFor="genero">Sexo</label>
                                <input id="genero"
                                    name="genero"
                                    className="form-control js-will-validate"
                                    type="text"
                                    value={sexo}
                                    disabled={true} />
                            </div>
                            {/* <div className="form-group form-group--genero">
                            <p>Genero <span className="required">*</span></p>
                            <Autocomplete
                                id="lstGenero"
                                value={valGenero}
                                options={listaGenero}
                                //getOptionSelected={(option, value) => option === value}
                                // getOptionSelected ={ (option, value) =>{
                                //     return  option?.descripcion.toLowerCase() === value?.descripcion.toLowerCase() || option?.ID === value?.ID
                                //  }}
                                noOptionsText={'No existe la opción.'}
                                //freeSolo={true}
                                size='small'
                                //getOptionLabel={option => option.descripcion}
                                getOptionLabel={(options: {
                                    descripcion: string;
                                    ID: number;
                                }) => toUpperCamelCase(options.descripcion)}
                                onChange={handleSelectGenero}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        variant='outlined'
                                        // label="Genero"
                                        placeholder="Seleccione Genero"
                                        margin="normal"
                                        fullWidth
                                        inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'new-password', 
                                        }}
                                    />
                                    )}
                                />
                        </div> */}
                            <div className="form-group form-group--direccion">
                                <label htmlFor="address">Dirección <span className="required">*</span></label>
                                <input id="address"
                                    name="address"
                                    className="form-control js-will-validate"
                                    type="text"
                                    value={direccion}
                                    onChange={(e: any) => setDireccion(e.target.value)} />
                            </div>
                            <div className="form-group form-group--genero">
                                <p>Comuna <span className="required">*</span></p>
                                <Autocomplete id="lstComuna"
                                    value={valComuna}
                                    options={listaComunas}
                                    noOptionsText={'No existe la opción.'}
                                    size='small'
                                    getOptionLabel={(options: {
                                        descripcion: string;
                                        ID: number;
                                    }) => toUpperCamelCase(options.descripcion)}
                                    onChange={handleSelectComuna}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant='outlined'
                                            placeholder="Seleccione comuna"
                                            margin="normal"
                                            label="Comuna"
                                            fullWidth
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password',
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            {/* <div className="form-group form-group--commune">
                            <Autocomplete
                                {...defaultProps}
                                id="auto-complete"
                                autoComplete
                                includeInputInList
                                renderInput={(params) => <TextField {...params} label="Comuna" margin="normal" />} />
                        </div> */}
                            {/* <div className="form-group">
                            <label htmlFor="telephone">Teléfono fijo</label>
                            <div className="personal-information__phones">
                                <span>+56</span>
                                <input
                                    id="telephone"
                                    name="telephone"
                                    className="form-control"
                                    type="text"
                                    value={telefonoFijo}
                                    onChange={(e:any) => setTelefonoFijo(e.target.value)}/>
                            </div>
                        </div> */}
                            <div className="form-group">
                                <label htmlFor="mobile-phone">Teléfono <span className="required">*</span></label>
                                <div className="personal-information__phones">
                                    <span>+56</span>
                                    <input id="mobile-phone"
                                        name="mobile-phone"
                                        className="form-control js-mobile js-will-validate"
                                        type="text"
                                        pattern="[0-9]*"
                                        max={9}
                                        maxLength={9}
                                        value={telefono}
                                        onChange={(e: any) => setTelefono(e.target.value)}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email Personal <span className="required">*</span></label>
                                <input id="email"
                                    name="email"
                                    className="form-control js-will-validate"
                                    type="email"
                                    value={mail}
                                    onChange={(e: any) => setMail(e.target.value)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Correo UDD</label>
                                <input id="emailUdd"
                                    name="emailUdd"
                                    className="form-control js-will-validate"
                                    type="email"
                                    disabled={true}
                                    value={mailUdd}
                                />
                            </div>
                            {/* <div className="form-group">
                            <div className="form-group form-group--nationality">
                                <label htmlFor="nationality">Nacionalidad <span className="required">*</span></label>
                                <input 
                                    id="nationality"
                                    name="nationality"
                                    className="form-control select-nationality js-will-validate" 
                                    type="text"
                                    value={nacionalidad}
                                    onChange={(e:any) => setNacionalidad(e.target.value)}/>
                            </div>
                        </div> */}
                            <div className="form-group form-group--nationality">
                                <p>Nacionalidad <span className="required">*</span></p>
                                <Autocomplete value={valPaisNacionalidad}
                                    options={listaPaisNacionalidad}
                                    size='small'
                                    getOptionLabel={(options: {
                                        descripcion: string;
                                        ID: number;
                                    }) => toUpperCamelCase(options.descripcion)}
                                    onChange={handleSelectPaisNacionalidad}
                                    renderInput={(
                                        params:
                                            | (JSX.IntrinsicAttributes & StandardTextFieldProps)
                                            | (JSX.IntrinsicAttributes & FilledTextFieldProps)
                                            | (JSX.IntrinsicAttributes & OutlinedTextFieldProps)
                                    ) => (
                                        <TextField
                                            {...params}
                                            variant='outlined'
                                            placeholder="Seleccione nacionalidad"
                                            label="Nacionalidad"
                                            margin="normal"
                                            inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'new-password',
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            {/* <div className="form-group form-group--nationality">
                            <Autocomplete
                                {...paisNacionalidadProps}
                                id="auto-complete"
                                autoComplete
                                includeInputInList
                                renderInput={(params) => <TextField {...params} label="Nacionalidad" margin="normal" />} />
                        </div> */}
                        </div>
                    </form>
                </div>
            </div>
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>)
}